import AdvertenciaHeader from "common/components/AdvertenciaHeader"
import { useTranslation } from "react-i18next"

const FacturasHeaderAdvertencia = () => {
  const { t } = useTranslation()
  return (
    <AdvertenciaHeader>
      <strong>{t("crear.facturaRec.warningMsg.firstBold")}</strong>
      {t("crear.facturaRec.warningMsg.firstNormal")}{" "}
      <strong>{t("crear.facturaRec.warningMsg.secondBold")}</strong>
      {t("crear.facturaRec.warningMsg.secondNormal")}
    </AdvertenciaHeader>
  )
}

export default FacturasHeaderAdvertencia
